<template>
    <div id="data-list-thumb-view" class="data-list-container">
        <new-wallet-off-setting
      ref="newWalletOffSetting"
      @saveData =getReports
      @close =removeSelected
    />
      <vs-table id="orderLogsTable" :max-items="itemsPerPage" :data="dayReports"
      v-model="selected">
        <div
          slot="header"
          class="w-full flex flex-wrap items-center flex-grow justify-between"
        >
          <vs-row vs-type="flex" vs-w="12" class="mb-1">
            <global-filter
              ref="filterer"
              :tableOptions="tableOptions"
              :filterOptions="filterOptions"
              :filterChips="filterChips"
              :filterOptionNames="filterOptionNames"
              :isActive="isFilterActive"
              @saveOptions="saveOptions"
              @close="isFilterActive = false"
            />
            <vs-row
              id="panelHeaderRow"
              v-show="!isFilterActive"
              vs-type="flex"
              vs-w="12"
              vs-justify="space-between"
            >
              <vs-col
                id="panel-actions"
                vs-type="flex"
                class="w-auto"
                vs-justify="center"
              >
                <vs-row vs-type="flex" vs-w="12">
                    <vs-col v-if="$isCenterBranch()" vs-type="flex" class="w-auto">
                  <vx-tooltip text="Yeni Mahsuplaşma" position="top">
                    <vs-button
                      @click="addNewWalletOfSetting"
                      class="panel-action text-success xlarge-button panel-action-box-shadow"
                      color="transparent"
                      icon-pack="feather"
                      icon="icon-plus"
                    >
                    </vs-button>
                  </vx-tooltip>
                </vs-col>
                  <vs-col vs-type="flex" vs-w="3.75">
                    <vx-tooltip text="Detaylı Filtereleme" position="top">
                      <vs-button
                        @click="isFilterActive = !isFilterActive"
                        class="panel-action text-warning xlarge-button panel-action-box-shadow"
                        color="transparent"
                        icon-pack="pickicon"
                        icon="icon-pick-filter"
                      >
                      </vs-button>
                    </vx-tooltip>
                  </vs-col>
                </vs-row>
              </vs-col>
              <vs-col id="filter-chips" vs-type="flex">
                <vs-row
                  vs-type="flex"
                  vs-w="12"
                  vs-justify="center"
                  vs-align="center"
                >
                  <vs-button
                    id="clearFilterButton"
                    v-if="filterChips.length > 0"
                    @click="clearFilter"
                    class="mr-2 bg-white text-danger panel-action-box-shadow"
                    icon-pack="feather"
                    icon="icon-slash"
                    radius
                    color="transparent"
                  />
                  <vs-col
                    vs-type="flex"
                    class="w-auto"
                    v-for="(chip, index) in filterChips"
                    :key="index"
                  >
                    <vs-chip
                      color="white"
                      class="panel-action-box-shadow px-1"
                      @click="removeFilter(chip.col, index)"
                      v-show="chip.value != ''"
                      closable
                    >
                      <vs-row vs-tpye="flex" vs-w="12">
                        <vs-col vs-tpye="flex" class="w-auto" vs-align="center">
                          <span class="bold text-xsmaller text-dark">
                            {{ chip.name + " :" }}
                          </span>
                        </vs-col>
                        <vs-col
                          vs-type="flex"
                          class="w-auto ml-1"
                          vs-align="center"
                        >
                          <feather-icon
                            v-if="chip.value === true"
                            icon="CheckIcon"
                            svgClasses="w-4 h-4 text-primary"
                          />
                          <feather-icon
                            v-else-if="chip.value === false"
                            icon="XIcon"
                          />
                          <span
                            v-else
                            class="weight-600 italic text-xsmaller text-primary"
                          >
                            {{ chip.value }}
                          </span>
                        </vs-col>
                      </vs-row>
                    </vs-chip>
                  </vs-col>
                </vs-row>
              </vs-col>
              <vs-col
                id="table-page-size"
                vs-type="flex"
                class="w-auto"
                vs-justify="flex-end"
              >
                <vs-dropdown
                  vs-trigger-click
                  class="bg-white cursor-pointer panel-action-box-shadow"
                >
                  <div
                    class="px-4 d-theme-border-grey-light d-theme-dark-bg cursor-pointer flex items-center justify-between text-small"
                  >
                    <span class="mr-2 page-size-dropdown-span"
                      >{{ (currentPage + 1) * itemsPerPage - (itemsPerPage - 1) }}
                      -
                      {{
                        totalDataRow - (currentPage + 1) * itemsPerPage > 0
                          ? (currentPage + 1) * itemsPerPage
                          : totalDataRow
                      }}
                      of
                      {{ totalDataRow }}</span
                    >
                    <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                  </div>
                  <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
                  <vs-dropdown-menu>
                    <vs-dropdown-item @click="itemsPerPage = 10">
                      <span>10</span>
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="itemsPerPage = 15">
                      <span>15</span>
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="itemsPerPage = 20">
                      <span>20</span>
                    </vs-dropdown-item>
                  </vs-dropdown-menu>
                </vs-dropdown>
              </vs-col>
            </vs-row>
          </vs-row>
        </div>
  
        <template slot="thead">
          <vs-th class="w-1/12 px-1">
            <vs-button
              class="p-1 weight-600"
              icon-pack="feather"
              :icon="tableOptions.sortBy == 'id' ? sortingHeadIcon : null"
              color="primary"
              type="flat"
              @click="setSortingOptions('id')"
              >Id
            </vs-button>
          </vs-th>
          <vs-th class="w-2/12">
            <vs-button
              class="p-1 weight-600"
              icon-pack="feather"
              :icon="tableOptions.sortBy == 'date' ? sortingHeadIcon : null"
              color="primary"
              type="flat"
              @click="setSortingOptions('date')"
              >Rapor Tarihi
            </vs-button>
          </vs-th>
          <vs-th class="w-2/12">
            <vs-button
              class="p-1 weight-600"
              icon-pack="feather"
              :icon="tableOptions.sortBy == 'created' ? sortingHeadIcon : null"
              color="primary"
              type="flat"
              @click="setSortingOptions('created')"
              >Kaydedilme Anı
            </vs-button>
          </vs-th>
          <vs-th class="w-2/12 px-1">
            <vs-button
              class="p-1 weight-600"
              icon-pack="feather"
              :icon="tableOptions.sortBy == 'branchId' ? sortingHeadIcon : null"
              color="primary"
              type="flat"
              @click="setSortingOptions('branchId')"
              >Şube
            </vs-button>
          </vs-th>
          <vs-th class="w-2/12 px-1" v-if="isDiffrencePermission">
            <vs-button
              class="p-1 weight-600"
              icon-pack="feather"
              :icon="tableOptions.sortBy == 'amount' ? sortingHeadIcon : null"
              color="primary"
              type="flat"
              @click="setSortingOptions('amount')"
              >Tutar
            </vs-button>
          </vs-th>
          <vs-th class="w-3/12 px-1">
            <vs-button
              class="p-1 weight-600"
              icon-pack="feather"
              :icon="
                tableOptions.sortBy == 'type' ? sortingHeadIcon : null
              "
              color="primary"
              type="flat"
              @click="setSortingOptions('type')"
              >Rapor Tipi
            </vs-button>
          </vs-th>
        </template>
  
        <template slot-scope="{ data }">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td class="w-1/12 text-center">
              {{ tr.id }}
            </vs-td>
            <vs-td class="w-2/12 text-center">
              {{ tr.dateString }}
            </vs-td>
            <vs-td class="w-2/12 text-center">
              {{ tr.timeString }}
            </vs-td>
            <vs-td class="w-2/12 text-center">
              {{ tr.branchName }}
            </vs-td>
            <vs-td class="w-2/12 text-center">
                <span class="text-success" v-if="tr.amount>0">
                   + {{ $toCurrency(tr.amount) }}
                </span>
                <span class="text-danger" v-if="tr.amount<0">
                    {{ $toCurrency(tr.amount) }}
                </span>
                <span class="text" v-if="tr.amount==0">
                    {{ $toCurrency(tr.amount) }}
                </span>
            </vs-td>
            <vs-td class="w-2/12 text-center">
              <span v-if="tr.type==0">Bakiye Transferi</span>
              <span v-if="tr.type==1">Şubeye Yapılan Ödeme</span>
              <span v-if="tr.type==2">Şubeye Yapılan Kesinti</span>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
      <!-- <vs-row vs-type="flex" vs-w="12" vs-justify="flex-end" vs-align="center">
        <span class="text-dark text-smaller weight-500"> Toplam Tutar : </span>
        <span class="text-primary text-small bold mr-1 ml-3">
          {{ getTotalAmount }} ₺
        </span>
      </vs-row> -->
      <vs-row v-if="selectedBranchName!=''" vs-type="flex" vs-w="12" vs-justify="flex-end" vs-align="center">
      <span class="text-dark text-smaller weight-500"> {{selectedBranchName}} Bakiyesi</span>
      <span class="text-primary text-small bold mr-1 ml-3">
        {{ selectedBranchBalance}} ₺
      </span>
    </vs-row>
      <vs-row vs-type="flex" vs-w="12">
        <pagination-default
          :setCurrentPage="tableOptions.pageIndex"
          :totalLenght="calculatePageLength"
          @currentPage="getCurrentPage"
        ></pagination-default>
      </vs-row>
    </div>
  </template>
  
  <script>
  import PaginationDefault from "../../PaginationDefault";
  import { GetPaged,GetBalance } from "@/api/BranchWalletTransaction";
  import GlobalFilter from "../../GlobalFilter";
  import {isGranted} from "@/utils/auth";
  import NewWalletOffSetting from "./NewWalletOffSetting.vue";
  export default {
    data() {
      return {
        tableOptions: {},
        sortingHeadIcon: "",
        sortingHeadIconBool: 1,
        currentPage: 0,
        itemsPerPage: 10,
        totalDataRow: 0,
        dayReports: [],
        isFilterActive: false,
        filterOptions: [
          "dateRange",
          "branch",
          "WalletOffSetType"
        ],
        filterOptionNames: [
          "Tarih",
          "Şube",
          "Mahsuplaşma Tipi"
        ],
        isFiltererOpen: false,
        filterChips: [],
        selected: "",
        selectedBranchName: "",
        selectedBranchBalance: 0
      };
    },
    components: {
      PaginationDefault,
      GlobalFilter,
      NewWalletOffSetting
    },
    computed: {
      isDiffrencePermission(){
      return isGranted("day_report_diffrence_read")
    },
      calculatePageLength() {
        let mod = this.totalDataRow % this.itemsPerPage;
        return mod > 0
          ? (this.totalDataRow - mod) / this.itemsPerPage + 1
          : this.totalDataRow / this.itemsPerPage;
      },
      getTotalAmount() {
        return this.dayReports.reduce(function (total, num) {
          return total + num.totalPrice;
        }, 0);
      },
    },
    methods: {
        addNewWalletOfSetting() {
            this.$refs.newWalletOffSetting.cloneNewOffSet = null;
      this.$refs.newWalletOffSetting.isActive = true;
    },
      saveOptions(filterOptions, filterChips) {
        console.log(filterChips);
        this.isFilterActive = false;
        if (_.isEqual(this.tableOptions, filterOptions)) return;
        this.tableOptions = _.cloneDeep(filterOptions);
        this.filterChips = _.cloneDeep(filterChips);
      },
      clearFilter() {
        this.tableOptions = {
          sortBy: "Created",
          sortDirection: "desc",
          pageIndex: 0,
          pageSize: this.itemsPerPage,
          dateRange: {
            startDate:
              this.$now().getHours() >= 0 && this.$now().getHours() <= 2
                ? this.$preDate()
                : this.$now.date(),
            endDate:
              this.$now().getHours() >= 0 && this.$now().getHours() <= 2
                ? this.$preDate()
                : this.$now.date(),
          },
          timeRange: {
            startTime: null,
            endTime: null,
          },
          paymentMethod: null,
          extra: null,
          product: null,
          personal: null,
          order: null,
          price: {
            min: null,
            max: null,
          },
          branch: this.$currentUser.branch,
          dayReportType:null
        };
        this.filterChips.length = 0;
      },
      removeFilter(col, index) {
        //if (col === "branch") this.tableOptions[col] = this.$currentUser.branch;
         this.tableOptions[col] = null;
        this.filterChips.splice(index, 1);
      },
      setSortingOptions(val) {
        if (this.tableOptions.sortBy != val) this.sortingHeadIconBool = 1;
        this.tableOptions.sortBy = val;
        switch (this.sortingHeadIconBool) {
          case 1:
            this.sortingHeadIconBool++;
            this.sortingHeadIcon = "icon-arrow-up";
            break;
          case 2:
            this.sortingHeadIconBool++;
            this.sortingHeadIcon = "icon-arrow-down";
            break;
          case 3:
            this.sortingHeadIconBool = 1;
            this.sortingHeadIcon = "";
            this.tableOptions.sortBy = "";
        }
      },
      getCurrentPage(currentx) {
        this.currentPage = currentx - 1;
      },
      removeSelected(){
        this.selected = '';
      },
      getReports() {
        console.log(this.tableOptions);
        this.selectedBranchName = this.tableOptions.branch != null ? this.tableOptions.branch.name : "";
            if (this.tableOptions.branch != null) {
                 GetBalance(this.tableOptions.branch.id).then((res) => {
                    this.selectedBranchBalance = res.data;
                });
                console.log(this.selectedBranchBalance);
            }else{
                this.selectedBranchBalance = 0;
            }
        GetPaged(this.tableOptions)
          .then((res) => {
            if (res && res.status == 200) {
              this.dayReports = res.data.items;
              this.totalDataRow = res.data.totalCount;
            } else {
              this.$vs.notify({
                color: "danger",
                title: "Hata : " + res.status,
                text: "Hata : " + res.status,
              });
            }
          })
          .catch(() => {
            this.$vs.notify({
              color: "danger",
              title: "Hata !",
              text: "Satış Kayıtları Yüklenemedi ! ",
            });
          });
      },
    },
    watch: {
      tableOptions: {
        deep: true,
        handler(val) {
          this.$nextTick(() => {
            console.log(this.tableOptions);
            
            this.getReports();
          });
        },
      },
      currentPage: function (val) {
        this.tableOptions.pageIndex = val;
      },
      selected(val) {
        console.log(val);
      if (val != "") {
        // this.$refs.newWalletOffSetting.isActive = true;
        // this.$refs.newWalletOffSetting.cloneNewOffSet = val;
      }
    },
      sortingHeadIconBool: function () {
        switch (this.sortingHeadIconBool) {
          case 1:
            this.tableOptions.sortDirection = "";
            break;
          case 2:
            this.tableOptions.sortDirection = "asc";
            break;
          case 3:
            this.tableOptions.sortDirection = "desc";
            break;
        }
        this.currentPage = 0;
        this.tableOptions.pageIndex = this.currentPage;
      },
      itemsPerPage: function (val) {
        this.currentPage = 0;
        this.tableOptions.pageSize = val;
        this.tableOptions.pageIndex = this.currentPage;
      },
    },
    created: function () {
      this.clearFilter();
      if (!this.$isCenterBranch()) {
        if (!this.$isRegionalCenterBranch()) {
          let branchPropIndex = this.filterOptions.indexOf("branch");
        this.filterOptions.splice(branchPropIndex, 1);
        this.filterOptionNames.splice(branchPropIndex, 1);
  
        delete this.tableOptions["branch"];
        }
        
      }
    },
  };
  </script>
  
  <style>
  .entryDetailRow {
    border-bottom: 0.1rem solid #d3d3d3;
  }
  
  .entryDetailPayment {
    justify-content: center;
    align-self: center;
  }
  
  #orderLogsTable .con-tablex {
    max-height: calc(100vh - 230px);
    overflow-y: auto;
  }
  </style>
  